import PageTitle from '../../../utils/PageTitle';
import cn from '../../../utils/cn';
import BasicSettingProvider from './BasicSettingProvider';
import BasicInfoEditableArea from './Components/BasicInfoEditableArea';
import UploadImage from './Components/UploadImage';

function SectionWrapper({ children, title = '', className }) {
    return (
        <div className={cn('border border-secondary-700 p-5 mb-4 rounded-10', { className })}>
            <div className="text-lg font-medium text-secondary border-b border-secondary-700 mb-4 -mx-5 pl-5 pb-5">
                {title}
            </div>
            {children}
        </div>
    );
}

function BasicSettingPage() {
    // set page title
    PageTitle(`Basic Settings`);

    return (
        <BasicSettingProvider>
            <div className="flex justify-center">
                <div className="w-full max-w-[900px] p-[50px] inner_page_cont">
                    <h1 className="w-full text-4xl font-medium text-primary border-b border-primary-100 pb-4 mb-5">
                        Basic Settings
                    </h1>
                    <BasicInfoEditableArea />

                    <SectionWrapper title="Portal Logo">
                        <UploadImage type="Logo" />
                    </SectionWrapper>
                    <SectionWrapper title="Login and forgot password page background image">
                        <UploadImage type="Background Image" />
                    </SectionWrapper>
                </div>
            </div>
        </BasicSettingProvider>
    );
}

export default BasicSettingPage;
